// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-content {
  --background: #fff !important;
}
:host ion-content .advice-row {
  background-color: white !important;
}
:host ion-list {
  background: var(--cms-app-background-color) !important;
}
:host .survey-list {
  margin-top: 0px;
  margin-bottom: 1rem;
  background-color: white !important;
}
:host .survey-list ion-list-header {
  margin-bottom: 0px;
  margin-top: 0px;
  padding-left: 0px;
}
:host .survey-list ion-item.item {
  --border-width: 1px;
  --border-color: var(--ion-color-light);
  --border-radius: 5px;
  border-radius: 5px;
}
:host .survey-list ion-button {
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
:host .survey-list .question-container {
  margin-bottom: 1em;
}
:host .photo-placeholder {
  --padding-start: 0;
  width: 100%;
  margin-bottom: 1em;
  background-color: var(--ion-color-light);
  border-radius: 8px;
  cursor: pointer;
  --inner-padding-end: 10px;
  --inner-padding-start: 10px;
  --inner-padding-top: 15px;
  position: relative;
}
:host .photo-placeholder i {
  position: absolute;
  top: 7px;
  right: 7px;
  border-radius: 50%;
  padding: 11px;
  height: 30px;
  width: 30px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  background-color: #f4f5f8;
  color: var(--cms-button-bg-color);
  box-shadow: 0 0 8px 3px #b8b8b8;
  z-index: 10;
}
:host .photo-placeholder img {
  width: 100%;
  text-align: center;
  object-fit: cover;
}
:host .document-placeholder {
  --padding-start: 0;
  width: 100%;
  margin-bottom: 1em;
  background-color: var(--ion-color-light);
  border-radius: 8px;
  cursor: pointer;
  --inner-padding-end: 10px;
  --inner-padding-start: 10px;
  --inner-padding-top: 15px;
  --inner-padding-bottom: 15px;
  position: relative;
}
:host .document-placeholder .document-container {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
}
:host .document-placeholder .document-container .document-icon {
  font-size: 24px;
  color: var(--ion-color-medium);
  flex-shrink: 0;
}
:host .document-placeholder .document-container .document-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
:host .document-placeholder .document-container .document-info .document-name {
  font-size: 14px;
  color: var(--ion-color-dark);
  font-weight: 500;
}
:host .document-placeholder .document-container .document-info .document-size {
  font-size: 12px;
  color: var(--ion-color-medium);
}
:host .document-placeholder .document-container .edit-icon {
  font-size: 18px;
  color: var(--ion-color-medium);
  flex-shrink: 0;
}
:host .document-placeholder i {
  position: absolute;
  top: 7px;
  right: 7px;
  border-radius: 50%;
  padding: 11px;
  height: 30px;
  width: 30px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  background-color: #f4f5f8;
  color: var(--cms-button-bg-color);
  box-shadow: 0 0 8px 3px #b8b8b8;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/survey-pages/full-screen-survey/full-screen-survey.scss"],"names":[],"mappings":"AACE;EACE,6BAAA;AAAJ;AAEI;EACE,kCAAA;AAAN;AAIE;EACE,sDAAA;AAFJ;AAKE;EACI,eAAA;EACA,mBAAA;EACA,kCAAA;AAHN;AAIM;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AAFR;AAQQ;EACE,mBAAA;EACA,sCAAA;EACA,oBAAA;EACA,kBAAA;AANV;AAWM;EACE,wBAAA;EACA,sBAAA;AATR;AAWM;EACE,kBAAA;AATR;AAaI;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;AAXN;AAaM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;EACA,+BAAA;EACA,WAAA;AAXR;AAcM;EACE,WAAA;EAEA,kBAAA;EACA,iBAAA;AAbR;AAiBI;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,4BAAA;EACA,kBAAA;AAfN;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AAfR;AAiBQ;EACE,eAAA;EACA,8BAAA;EACA,cAAA;AAfV;AAkBQ;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAhBV;AAkBU;EACE,eAAA;EACA,4BAAA;EACA,gBAAA;AAhBZ;AAmBU;EACE,eAAA;EACA,8BAAA;AAjBZ;AAqBQ;EACE,eAAA;EACA,8BAAA;EACA,cAAA;AAnBV;AAuBM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;EACA,+BAAA;EACA,WAAA;AArBR","sourcesContent":[":host {\n  ion-content {\n    --background: #fff !important;\n\n    .advice-row {\n      background-color: white !important;\n    }\n  }\n\n  ion-list {\n    background: var(--cms-app-background-color) !important;\n  }\n\n  .survey-list {\n      margin-top: 0px;\n      margin-bottom: 1rem;\n      background-color: white !important;\n      ion-list-header {\n        margin-bottom: 0px;\n        margin-top: 0px;\n        padding-left: 0px;\n      }\n  \n      ion-item{\n\n        \n        &.item{\n          --border-width: 1px;\n          --border-color: var(--ion-color-light);\n          --border-radius: 5px;\n          border-radius: 5px;\n        }\n  \n      }\n  \n      ion-button {\n        margin-inline-start: 0px;\n        margin-inline-end: 0px;\n      }\n      .question-container{\n        margin-bottom: 1em;\n      }\n    }\n\n    .photo-placeholder {\n      --padding-start: 0;\n      width: 100%;\n      margin-bottom: 1em;\n      background-color: var(--ion-color-light);\n      border-radius: 8px;\n      cursor: pointer;\n      --inner-padding-end: 10px;\n      --inner-padding-start: 10px;\n      --inner-padding-top: 15px;\n      position: relative;\n  \n      i {\n        position: absolute;\n        top: 7px;\n        right: 7px;\n        border-radius: 50%;\n        padding: 11px;\n        height: 30px;\n        width: 30px;\n        display: flex !important;\n        align-items: center;\n        justify-content: center;\n        background-color: #f4f5f8;\n        color: var(--cms-button-bg-color);\n        box-shadow: 0 0 8px 3px #b8b8b8;\n        z-index: 10;\n      }\n  \n      img {\n        width: 100%;\n        //max-height: 200px;\n        text-align: center;\n        object-fit: cover;\n      }\n    }\n\n    .document-placeholder {\n      --padding-start: 0;\n      width: 100%;\n      margin-bottom: 1em;\n      background-color: var(--ion-color-light);\n      border-radius: 8px;\n      cursor: pointer;\n      --inner-padding-end: 10px;\n      --inner-padding-start: 10px;\n      --inner-padding-top: 15px;\n      --inner-padding-bottom: 15px;\n      position: relative;\n\n      .document-container {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        gap: 12px;\n\n        .document-icon {\n          font-size: 24px;\n          color: var(--ion-color-medium);\n          flex-shrink: 0;\n        }\n\n        .document-info {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          gap: 4px;\n\n          .document-name {\n            font-size: 14px;\n            color: var(--ion-color-dark);\n            font-weight: 500;\n          }\n\n          .document-size {\n            font-size: 12px;\n            color: var(--ion-color-medium);\n          }\n        }\n\n        .edit-icon {\n          font-size: 18px;\n          color: var(--ion-color-medium);\n          flex-shrink: 0;\n        }\n      }\n\n      i {\n        position: absolute;\n        top: 7px;\n        right: 7px;\n        border-radius: 50%;\n        padding: 11px;\n        height: 30px;\n        width: 30px;\n        display: flex !important;\n        align-items: center;\n        justify-content: center;\n        background-color: #f4f5f8;\n        color: var(--cms-button-bg-color);\n        box-shadow: 0 0 8px 3px #b8b8b8;\n        z-index: 10;\n      }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
